var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnverifiedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_9139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 1.93661C5.56367 1.32124 6.77115 0.998115 8 1.00001C11.8661 1.00001 15 4.13391 15 8C15 11.8661 11.8661 15 8 15C4.1339 15 1 11.8661 1 8C1 6.7253 1.3409 5.52901 1.9366 4.50001",
    stroke: "#FA4D4D",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99922 9.6C7.78705 9.6 7.58356 9.51081 7.43353 9.35206C7.2835 9.19331 7.19922 8.978 7.19922 8.75349V4.84651C7.19922 4.622 7.2835 4.40669 7.43353 4.24794C7.58356 4.08919 7.78705 4 7.99922 4C8.21139 4 8.41488 4.08919 8.5649 4.24794C8.71493 4.40669 8.79922 4.622 8.79922 4.84651V8.75349C8.79922 8.978 8.71493 9.19331 8.5649 9.35206C8.41488 9.51081 8.21139 9.6 7.99922 9.6Z",
    fill: "#FA4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99922 12.0004C8.44105 12.0004 8.79922 11.6422 8.79922 11.2004C8.79922 10.7586 8.44105 10.4004 7.99922 10.4004C7.55739 10.4004 7.19922 10.7586 7.19922 11.2004C7.19922 11.6422 7.55739 12.0004 7.99922 12.0004Z",
    fill: "#FA4D4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_9139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnverifiedIcon);
export default __webpack_public_path__ + "static/media/unverifiedIcon.df98fd0544928c008771a247e13249c8.svg";
export { ForwardRef as ReactComponent };